<template>
  <div class="container card">
    <h1 style="display: flex; align-items: center; gap: 0.5em; justify-content: center;">
      <img src="./assets/train.png" alt="Tren" style="height:1.5em; display: inline-block; vertical-align: middle; margin-bottom: 0.15em;">
      <span style="font-size: 1.2em; font-weight: bold;">AVE-card</span>
    </h1>
    
    <VCardForm 
      :qr-image="qrImage" 
      :is-generating="isGenerating"
      @generate="handleGenerateQR"
      @clear="clearQRImage"
    />

    <QRCodeDisplay :qr-image="qrImage" />
  </div>
</template>

<script>
import QRCode from 'qrcode'
import { generateVcard } from './utils/vcard-generator'
import VCardForm from './components/VCardForm.vue'
import QRCodeDisplay from './components/QRCodeDisplay.vue'

export default {
  name: 'App',
  components: {
    VCardForm,
    QRCodeDisplay
  },
  data() {
    return {
      qrImage: null,
      isGenerating: false
    }
  },
  methods: {
    async handleGenerateQR(formData) {
      this.isGenerating = true
      
      try {
        const vcard = generateVcard(
          formData.firstName,
          formData.phone,
          formData.email,
          formData.lastName,
          formData.company,
          formData.jobTitle
        )
        
        const qrDataUrl = await QRCode.toDataURL(vcard, {
          errorCorrectionLevel: 'L',
          margin: 4,
          scale: 10,
          color: {
            dark: '#000000',
            light: '#ffffff'
          }
        })
        
        this.qrImage = qrDataUrl
      } catch (error) {
        console.error('Error generando el código QR:', error)
        alert('Ha ocurrido un error al generar el código QR. Por favor, inténtalo de nuevo.')
      } finally {
        this.isGenerating = false
      }
    },
    clearQRImage() {
      this.qrImage = null
    }
  }
}
</script>

<style>
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

body {
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  margin: 0;
  padding: 20px;
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}

.container.card {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  border-radius: 20px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
  padding: 40px 30px;
  max-width: 450px;
  width: 100%;
  text-align: center;
  border: 1px solid rgba(255, 255, 255, 0.2);
}

h1 {
  font-size: 32px;
  font-weight: 700;
  color: #2d3748;
  margin-bottom: 30px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

form {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

/* Animation for form appearance */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.container.card {
  animation: fadeInUp 0.6s ease-out;
}

/* Responsive design */
@media (max-width: 480px) {
  .container.card {
    margin: 10px;
    padding: 30px 20px;
    max-width: none;
  }
  
  h1 {
    font-size: 28px;
  }
}
</style>